<template>
    <!-- IE 2026 10 18 / ODOO-347310: ссылка на запись в системе-источнике (Odoo и т.п.) — открывается в новой вкладке -->
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <div class="wj-labeled-input attr-url" :style="attr.cssStyle||'max-width: 25rem !important;'" v-wjTooltip="attr.tooltip">
            <div class="attr-element attr-url-row" :class="attr.cssClass" :id="attr.html_id">
                <a v-if="url" class="attr-url-link" :href="url" target="_blank" rel="noopener noreferrer" :title="url">
                    <i class="pi pi-external-link"></i><span>{{ label }}</span>
                </a>
                <span v-else class="attr-url-empty">—</span>
                <input v-if="!isReadOnly" class="attr-url-input" type="url" :value="raw" @change="onChange($event)" :placeholder="t('URL')" />
            </div>
            <label v-if="attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</label>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { safeHttpUrl, linkLabel } from '@/utils/sourceLink'

export default {
    props: ['widget_id', 'attr_id'],
    data: () => ({ WIDGET: {}, raw: '' }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    methods: {
        content_Changed() {
            this.store.widget_attr_set(this)
            const v = this.store.attr_get(this.WIDGET, this.attr)
            this.raw = typeof v === 'string' ? v : (v?.value || '')
        },
        onChange(e) {
            const v = String(e.target.value || '').trim()
            if (v === this.raw) return
            this.raw = v
            this.store.attr_set(this.WIDGET, this.attr, v)
        },
    },
    computed: {
        url() { return safeHttpUrl(this.raw) },
        label() { return linkLabel(this.url, this.attr?.linkText) },
        isReadOnly() {
            // значение приходит из meta загруженной записи (DS-колонка) — по умолчанию только чтение
            return this.WIDGET?.isReadOnly || this.attr?.isReadOnly || this.attr?.fieldMapping?.use || !this.attr?.editable
        },
    },
}
</script>

<style scoped>
.attr-url { width: -webkit-fill-available !important; }
.attr-url-row { display: flex; align-items: center; gap: 8px; min-height: 1.8rem; border-bottom: 1px solid var(--surface-border, #cbd5e1); }
.attr-url-link { display: inline-flex; align-items: center; gap: 6px; color: var(--primary-color, #2563eb); text-decoration: none; font-weight: 500; }
.attr-url-link:hover { text-decoration: underline; }
.attr-url-empty { color: var(--text-color-secondary, #94a3b8); }
.attr-url-input { flex: 1; border: 0; background: transparent; outline: none; min-width: 6rem; }
</style>
